<template>
  <span
    class="text-white leading-none uppercase flex flex-row gap-0.5 kind-name items-center"
  >
    <span
      v-if="isFortress && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isFortress"
      class="bg-wonder-fortress"
    >
      Fortress
    </span>
    <span
      v-if="isStatue && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isStatue"
      class="bg-wonder-statue"
    >
      Statue
    </span>
    <span
      v-if="isTemple && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isTemple"
      class="bg-wonder-temple"
    >
      Temple
    </span>
    <span
      v-if="isArena && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isArena"
      class="bg-wonder-arena"
    >
      Arena
    </span>
    <span
      v-if="isPalace && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isPalace"
      class="bg-wonder-palace"
    >
      Palace
    </span>
    <span
      v-if="isNature && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isNature"
      class="bg-wonder-nature"
    >
      Nature
    </span>
    <span
      v-if="isNaval && isMultiple"
      class="text-sm leading-none uppercase font-medium text-black"
    >2x</span
    >
    <span
      v-if="isNaval"
      class="bg-wonder-naval"
    >
      Naval
    </span>
  </span>
</template>

<script>
import WonderKind from "@/roc/wonders/base/WonderKind";
import {computed} from 'vue';

export default {
  props: {
    kind: {
      type: Number,
      required: true
    },
    kindMultiplier: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    return {
      isFortress: computed(() => {
        return (props.kind & WonderKind.FORTRESS) !== 0;
      }),
      isStatue: computed(() => {
        return (props.kind & WonderKind.STATUE) !== 0;
      }),
      isTemple: computed(() => {
        return (props.kind & WonderKind.TEMPLE) !== 0;
      }),
      isPalace: computed(() => {
        return (props.kind & WonderKind.PALACE) !== 0;
      }),
      isArena: computed(() => {
        return (props.kind & WonderKind.ARENA) !== 0;
      }),
      isNature: computed(() => {
        return (props.kind & WonderKind.NATURE) !== 0;
      }),
      isNaval: computed(() => {
        return (props.kind & WonderKind.NAVAL) !== 0;
      }),
      isMultiple: computed(() => {
        return props.kindMultiplier > 1;
      })
    };
  }
};
</script>

<style scoped>
.kind-name > span {
  padding: 2px;
  font-size: 10px;
  font-weight: 500;
}
</style>
